import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IComplianceInvestigationDetails } from "../../api/IComplianceInvestigation";
import { ILicenceProfile } from "../../api/LicenceProfile";
import { GetComplianceRecordDetailsUrl } from "../../leap-pages/routeFactory";
import EpaCard from "../EpaCard";
import EpaField2Rows from "../EpaField2Rows";

const complianceInvestigation = "Compliance Investigation";

interface IComplianceInvestigationBoxProps {
  complianceInvestigationDetails: IComplianceInvestigationDetails;
  licenceProfile: ILicenceProfile;
}

const ComplianceInvestigationBox = ({
  complianceInvestigationDetails,
  licenceProfile,
}: IComplianceInvestigationBoxProps) => {
  var bodyElements = (
    <Row>
      <Col className="col-12 col-md-6">
        <Row>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Reference No."}
              content={
                <Link
                  to={GetComplianceRecordDetailsUrl(
                    complianceInvestigationDetails.complianceinvestigationid,
                    "Compliance Investigation",
                    licenceProfile.profileNo
                  )}
                >
                  {complianceInvestigationDetails.reference}
                </Link>
              }
            />
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Date Raised by EPA"}
              value={complianceInvestigationDetails.dateraised}
            />
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Status"}
              value={complianceInvestigationDetails.status}
            />
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Issue / Theme"}
              value={complianceInvestigationDetails.subject}
            />
          </Col>
        </Row>
      </Col>
      <Col className="col-12 col-md-6">
        <EpaField2Rows
          label={"Title"}
          value={complianceInvestigationDetails.title}
        />
      </Col>
    </Row>
  );

  return (
    <EpaCard
      title={"Associated with Compliance Investigation"}
      content={bodyElements}
    />
  );
};

export { ComplianceInvestigationBox };
